import styled from 'styled-components';
import NextImage from 'next/image';
import { colors } from 'constants/theme';
import MEDIA from 'helpers/mediaTemplates.js';
export const ImageWrapper = styled.div.withConfig({
  displayName: "imagecss__ImageWrapper",
  componentId: "sc-1f8xre3-0"
})(["position:relative;width:100%;margin:0px auto;line-height:0;box-shadow:-1px 3px 6px 1px rgba(0,0,0,0.3);> a{font-size:0;}"]);
export const SImage = styled(NextImage).withConfig({
  displayName: "imagecss__SImage",
  componentId: "sc-1f8xre3-1"
})(["max-width:100%;height:auto;"]);
export const ImageFrame = styled.div.withConfig({
  displayName: "imagecss__ImageFrame",
  componentId: "sc-1f8xre3-2"
})(["position:absolute;bottom:15px;left:15px;top:15px;right:15px;opacity:0;transition:opacity 150ms ease-in-out;", ""], MEDIA.PHONE`
    opacity: 1;
  `);
export const ImageHeader = styled.div.withConfig({
  displayName: "imagecss__ImageHeader",
  componentId: "sc-1f8xre3-3"
})(["position:absolute;top:0px;right:0px;svg{filter:invert(100%) drop-shadow(0 1px 2px rgba(0,0,0,0.5));}"]);
export const ImageFooter = styled.div.withConfig({
  displayName: "imagecss__ImageFooter",
  componentId: "sc-1f8xre3-4"
})(["text-shadow:0 1px 2px rgba(0,0,0,0.5);color:", ";line-height:1;width:100%;"], colors.white);
export const ImageTitle = styled.span.withConfig({
  displayName: "imagecss__ImageTitle",
  componentId: "sc-1f8xre3-5"
})(["position:absolute;bottom:0px;left:0px;font-size:14px;"]);
export const ImageCopyright = styled.span.withConfig({
  displayName: "imagecss__ImageCopyright",
  componentId: "sc-1f8xre3-6"
})(["position:absolute;bottom:0px;right:0px;font-size:10px;"]);
export const FlickrContainer = styled.div.withConfig({
  displayName: "imagecss__FlickrContainer",
  componentId: "sc-1f8xre3-7"
})(["padding:1rem 0 1rem 0;"]);
export const ImageContainer = styled(ImageWrapper).withConfig({
  displayName: "imagecss__ImageContainer",
  componentId: "sc-1f8xre3-8"
})(["overflow:hidden;width:fit-content;transition:all 0.2s ease-in-out;img{transition:transform 2s;}:hover{", "{opacity:1;cursor:pointer;}img{transform:scale(1.02);}}"], ImageFrame);